// src/pages/AuthPage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../components/auth/Login';
import { useAuth } from '../context/AuthContext';

function AuthPage() {
  const { currentUser, userRole } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in, redirect based on role
    if (currentUser) {
      if (userRole === 'admin') {
        navigate('/admin');
      } else if (userRole === 'mentor') {
        navigate('/mentor');
      } else {
        navigate('/learner');
      }
    }
  }, [currentUser, userRole, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>Portfolio System</h1>
          <p>Login to access your dashboard</p>
        </div>
        
        <Login />
      </div>
    </div>
  );
}

export default AuthPage;